/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
import React from 'react';
import Grid from '@material-ui/core/Grid';
import Dialog from '@material-ui/core/Dialog';
import Typography from '@material-ui/core/Typography';
import withStyles from '@material-ui/core/styles/withStyles';
import CloseIcon from '@material-ui/icons/Close';
import ReactMarkdown from 'react-markdown';
import {
    string, bool, shape, object, func, arrayOf,
} from 'prop-types';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import ResponsiveImage from '../../../GraphqlCommonComponents/ResponsiveImage/ResponsiveImage';

const styles = () => ({
    mainHeader: {
        paddingBottom: 0,
        '& h2': {
            fontSize: 18,
            fontWeight: 'bold',
        },
    },
    contentWrapper: {
        padding: '8px 0px 0px 0px',
        '& p': {
            margin: 0,
            fontSize: 13,
        },
        '& li': {
            fontSize: 13,
        },
    },
    mainContent: {
        padding: '0 24px',
    },
    closeIcon: {
        position: 'absolute',
        right: '3%',
        cursor: 'pointer',
    },
    holidayShipping: {
        display: 'flex',
        padding: '16px 24px',
    },
    infoImage: {
        margin: '3px 15px 0px 0px',
        marginRight: 17,
    },
    healthSafetyBlock: {
        padding: '16px 24px',
        '& h2': {
            fontSize: 18,
            marginTop: 0,
        },
    },
    modalWrapper: {
        padding: 10,
    },
});

const PDPDeliveryPopup = ({
    openModal, classes, popUpData, closeModal,
}) => {
    const data = popUpData?.[0] || [];
    const healthSafety = data?.health_safety_measures || {};
    const holidaySeasson = data?.holiday_season_shipping_partners_alert || {};
    return (
        <Dialog open={openModal} className={classes.modalWrapper}>
            <DialogTitle className={classes.mainHeader}>
                <Grid item className={classes.closeIconWrapper}>
                    <CloseIcon className={classes.closeIcon} onClick={closeModal} data-testid="close-button" />
                </Grid>
                {data?.main_header}
            </DialogTitle>
            <DialogContent className={classes.contentWrapper}>
                <ReactMarkdown source={data?.main_markdown} className={classes.mainContent} />
                {healthSafety?.health_safety_header && (
                    <div
                        className={classes.healthSafetyBlock}
                        style={{
                            color: `${healthSafety?.health_safety_text_color || '#000'}`,
                            background: `${healthSafety?.health_safety_background_color || '#EFEFEF'}`,
                        }}
                    >
                        <h2>{healthSafety?.health_safety_header}</h2>
                        <Typography>
                            <ReactMarkdown source={healthSafety?.health_safety_markdown} />
                        </Typography>
                    </div>
                )}
                {holidaySeasson?.alert_markdown && (
                    <div
                        className={classes.holidayShipping}
                        style={{
                            color: `${holidaySeasson?.alert_text_color || '#000'}`,
                            background: `${holidaySeasson?.alert_background_color || '#FFE200'}`,
                        }}
                    >
                        <ResponsiveImage path={holidaySeasson?.alert_image?.url} alt={holidaySeasson?.alert_image?.title} className={classes.infoImage} />
                        <Typography>
                            <ReactMarkdown source={holidaySeasson?.alert_markdown} />
                        </Typography>
                    </div>
                )}
            </DialogContent>

        </Dialog>

    );
};
PDPDeliveryPopup.propTypes = {
    popUpData: arrayOf(shape({
        main_header: string.isRequired,
        main_markdown: string.isRequired,
        holiday_season_shipping_partners_alert: shape({
            alert_markdown: string.isRequired,
            alert_image: shape({
                url: string.isRequired,
                title: string.isRequired,
            }).isRequired,
        }).isRequired,
        health_safety_measures: shape({
            health_safety_header: string.isRequired,
            health_safety_markdown: string.isRequired,
        }).isRequired,
    })),
    openModal: bool.isRequired,
    closeModal: func.isRequired,
    classes: object.isRequired,
};

PDPDeliveryPopup.defaultProps = {
    popUpData: [],
};

export default withStyles(styles)(PDPDeliveryPopup);
